import React, { useState, FC, useEffect } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { AccountCircle, Search as SearchIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useRecoilState } from "recoil";
import { userState } from "../../../../states/userState";
import { setUserToLocalStorage } from "../../../../lib/localStorageManager";
import {
  backgroundColor,
  foreColor,
  foreColorOnMouseOver,
} from "../../../../commons/colors";
type Props = {
  fullWidth: boolean;
  label: string;
  multiline: boolean;
  required: boolean;
  rows: number;
  type: string;
  InputProps?: TextFieldProps["InputProps"];
  disabled: boolean;
  value: string;
};
const TextInputForCard: FC<Props> = (props) => {
  const [user, setUser] = useRecoilState(userState);

  return (
    <TextField
      // color={"#0adcc0"}
      variant="standard"
      fullWidth={props.fullWidth}
      label={props.label}
      InputLabelProps={{ shrink: true }}
      margin="dense"
      multiline={props.multiline}
      required={props.required}
      rows={props.rows}
      value={props.value}
      type={props.type}
      disabled={props.disabled}
      InputProps={{
        ...props.InputProps,
        readOnly: true,
        endAdornment: props.InputProps ? (
          // <InputAdornment position="start">
          //   <div
          //     style={{
          //       backgroundColor: "#0adcc0",
          //       width: "36px",
          //       height: "20px",
          //       paddingLeft: "6px",
          //       borderRadius: "5px",
          //       cursor: "pointer",
          //     }}
          //     onClick={props.onClick}
          //   >
          //     <SearchIcon />
          //   </div>
          // </InputAdornment>
          <></>
        ) : null,
        sx: {
          "& .MuiInput-underline:before": {
            borderBottomColor: foreColor(user?.mode ?? "lite"), // 通常時の下線の色
          },
          "& .MuiInput-underline:after": {
            borderBottomColor: foreColor(user?.mode ?? "lite"), // フォーカス時の下線の色
          },
          "& .MuiInput-underline:hover:before": {
            borderBottomColor: `${foreColor(user?.mode ?? "lite")}!important`, // ホバー時の下線の色
          },
          "& .MuiInput-underline": {
            borderBottomColor: `${foreColor(user?.mode ?? "lite")}!important`, // ホバー時の下線の色
          },
          // 他のスタイルもここに追加できます
        },
      }}
      sx={{
        margin: "20px 0",

        "&&&": {
          // color: "blue",
          width: "240px",
          height: "42px",
          backgroundColor: backgroundColor(user?.mode ?? "lite"),
          padding: "5px 10px 2px 10px",
          borderRadius: "5px",
        },
        "& label": {
          padding: "10px",
          color: foreColor(user?.mode ?? "lite"),
          fontSize: "18px",
        },
        "& svg": {
          // marginTop: "5px",
          color: "#f0f2f5",
        },
        "& input": {
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: "5px",
          paddingLeft: "2px",
          fontSize: "16px",
          color: foreColor(user?.mode ?? "lite"),
          fontWeight: "700",
          "&:hover": {
            color: foreColor(user?.mode ?? "lite"),
          },
          "&:focus": {
            color: foreColor(user?.mode ?? "lite"),
          },
          //   backgroundColor: "black",
        },
        "& .MuiSvgIcon-root": {
          color: "#f0f2f5",
        },
        "& .MuiInputBase-input": {
          fontSize: "16px",
          color: foreColor(user?.mode ?? "lite"),
          fontWeight: "700",
        },
        // InputPropsで指定したスタイル以外にもここで追加できます
      }}
    />
  );
};
export default TextInputForCard;
